var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69521 27.2811L1 31.0622L23.4999 46L45.9999 31.0622L40.3046 27.2811",
    fill: "#EBF5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69521 27.2811L1 31.0622L23.4999 46L45.9999 31.0622L40.3046 27.2811",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6953 19.7186L1 23.4997L23.4999 38.4375L45.9999 23.4997L40.3045 19.7186",
    fill: "#EBF5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6953 19.7186L1 23.4997L23.4999 38.4375L45.9999 23.4997L40.3045 19.7186",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46 15.9372L23.5 30.875L1 15.9372L23.5 0.999481L46 15.9372Z",
    fill: "url(#paint0_linear_2727_198)",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2395 16.3574L23.4987 8.56271L11.7578 16.3574",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5444 20.1387L23.4988 16.125L17.4531 20.1387",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2727_198",
    x1: 8.5,
    y1: 6,
    x2: 39.3689,
    y2: 13.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollect);
export default __webpack_public_path__ + "static/media/Collect.bceb357ef8c55863b24de972322b95aa.svg";
export { ForwardRef as ReactComponent };